import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AutoComplete from 'material-ui/AutoComplete';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';

import { updateCargoOrder } from 'actions/cargoes/orders';
import { addNotification } from 'actions/notifications/notifications';
import api from 'services';

class Name extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cargoNames: [],
            cargoName: props.cargoOrder.cargoName,
            isShowDialog: false,
            names: [],
        };

        this.dAutocomplete = _.debounce((searchText) => {
            api.getCargoNamesAutocomplete(searchText)
                .then((response) => {
                    const cargoNames = response.data.data.map(cargoName => ({
                        name: cargoName.name,
                        item: cargoName,
                        details: cargoName.details,
                    }));

                    this.setState({
                        cargoNames,
                    });
                }).then(() => {
                    const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
                    newCargoOrder.cargoName = searchText;
                    this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
                })
                .catch(() => null);
        }, 1000);


        this.onChangeAutoCompleteCargoName = this.onChangeAutoCompleteCargoName.bind(this);
        this.onChooseAutoCompleteCargoName = this.onChooseAutoCompleteCargoName.bind(this);
        this.toggleDialog = this.toggleDialog.bind(this);
        this.changeSearch = this.changeSearch.bind(this);
        this.chooseCargoName = this.chooseCargoName.bind(this);
    }

    chooseCargoName(cargo) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);

        newCargoOrder.cargoName = cargo.realCargoName;
        newCargoOrder.cargoType = cargo.CargoCategory;
        newCargoOrder.cargoTypeName = cargo.CargoCategoryName;

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);

        this.setState({
            isShowDialog: !this.state.isShowDialog,
        });
    }

    searchInPopup(value) {
        return this.props.cargoAssigners.filter((cargoAssigner) => {
            if (cargoAssigner.value
                && cargoAssigner.value.toLowerCase().includes(value.toLowerCase())) {
                return true;
            }

            if (cargoAssigner.realCargoName
                && cargoAssigner.realCargoName.toLowerCase().includes(value.toLowerCase())) {
                return true;
            }

            return false;
        });
    }

    changeSearch(e, value) {
        const names = this.searchInPopup(value);

        this.setState({
            names,
            cargoName: value,
        });
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            cargoName: props.cargoOrder.cargoName,
        });
    }

    onChangeAutoCompleteCargoName(searchText) {
        this.setState({
            cargoName: searchText,
        }, () => {
            this.dAutocomplete(searchText);
        });
    }

    onChooseAutoCompleteCargoName = (updateProperties) => {
        if (!updateProperties) {
            return;
        }

        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);

        newCargoOrder.cargoName = updateProperties.name;
        newCargoOrder.cargoId = updateProperties._id;
        newCargoOrder.cargoType = updateProperties.item.parent.red._id;
        newCargoOrder.cargoTypeName = updateProperties.item.parent.red.name;
        newCargoOrder.details = updateProperties.details;
        newCargoOrder.filterCategory = updateProperties.item.parent.red.name;

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);

        this.setState({
            cargoNames: [],
        });
    }

    toggleDialog() {
        const { cargoName } = this.state;
        if (!cargoName) {
            this.props.addNotification({
                title: 'Error',
                message: 'Cargo name should be specified',
                level: 'error',
                _id: Math.random(),
                autoDismiss: 2,
            });
        } else {
            const names = this.searchInPopup(cargoName);
    
            this.setState({
                isShowDialog: !this.state.isShowDialog,
                names,
            });
        }
    }

    render() {
        const errorCargoName = this.props.errorCargoName ? this.props.errorCargoName.messages[0] : '';
        const actions = [
            <FlatButton
                label='Cancel'
                primary
                onClick={this.toggleDialog}
            />,
        ];

        return (
            <div className='row'>
                <Dialog
                    className='find-similar-popup'
                    title='Find similar (max 10)'
                    actions={actions}
                    open={this.state.isShowDialog}
                    onRequestClose={this.toggleDialog}
                >
                    <div className='search-block'>
                        <TextField
                            floatingLabelText='Search cargo names'
                            onChange={this.changeSearch}
                            value={this.state.cargoName}
                        />
                    </div>
                    <div className='result-header'>
                        <div className='result-line'>
                            <div className='name'>
                                    Cargo real name
                            </div>
                            <div className='name'>
                                    Cargo name
                            </div>
                            <div className='button' />
                        </div>
                    </div>
                    <div className='result-body'>
                        {
                            this.state.names.map((cargoAssigner, i) => {
                                if (i < 30) {
                                    return (
                                        <div key={`${cargoAssigner.value}_${i}`} className='result-line'>
                                            <div className='name'>{cargoAssigner.realCargoName}</div>
                                            <div className='name'>{cargoAssigner.value}</div>
                                            <div className='button'>
                                                <RaisedButton
                                                    labelStyle={{ fontSize: '10px' }}
                                                    style={{ height: '25px' }}
                                                    buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                                    label='Choose'
                                                    primary
                                                    onClick={() => { this.chooseCargoName(cargoAssigner); }}
                                                />
                                            </div>
                                        </div>
                                    );
                                }
                            })
                        }
                    </div>
                </Dialog>
                <div className='column-left'>
                    Cargo name:
                </div>
                <div className='column-right'>
                    <AutoComplete
                        name='cargoName'
                        textFieldStyle={{ fontSize: '13px' }}
                        hintText='Cargo name'
                        errorText={errorCargoName}
                        searchText={this.state.cargoName}
                        dataSource={this.state.cargoNames}
                        dataSourceConfig={{ text: 'name', value: 'item' }}
                        onUpdateInput={this.onChangeAutoCompleteCargoName}
                        onNewRequest={this.onChooseAutoCompleteCargoName}
                        filter={AutoComplete.noFilter}
                        listStyle={{ overflow: 'auto', maxHeight: '300px', width: 'auto' }}
                        menuStyle={{ width: 'auto' }}
                        popoverProps={{
                            canAutoPosition: true,
                        }}
                    />
                    <RaisedButton
                        labelStyle={{ fontSize: '10px' }}
                        style={{ height: '25px' }}
                        buttonStyle={{ height: '25px', lineHeight: '25px' }}
                        label='Find in names'
                        primary
                        onClick={this.toggleDialog}
                    />
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const errorCargoName = state.cargoOrders.items[ownProps.numberOrderTable].validateErrors.find(validateError => validateError.field === 'cargo.0.cargoName');
        
        return {
            numberOrderTable: ownProps.numberOrderTable,
            errorCargoName,
            cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable],
            cargoAssigners: state.cargoAssigners.items,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder,
        addNotification,
    }, dispatch),
)(Name);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Name.jsx